import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "templates"
}
const _hoisted_2 = { class: "hint" }

import {onMounted, ref, watch} from "vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import notificationService from "@/shared/services/NotificationService";
import apiRegistrationInquiry, {InquiryTemplate} from "@/modules/RegistrationInquiry/api";

interface Props {
  insurerId: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RegistrationInquiryTemplatesComponent',
  props: {
    insurerId: {}
  },
  setup(__props: any) {

const props = __props;

const _items = ref<InquiryTemplate[]>([]);
const _selected = ref<InquiryTemplate | undefined>(undefined);
const _editSubject = ref("");
const _editBody = ref("");

async function load() {
  _selected.value = undefined;
  _items.value = (await apiRegistrationInquiry.templates(props.insurerId)) ?? [];
}

// nur eine Art gleichzeitig: Auswahl einer Art öffnet deren Bearbeitung
function onSelect(item: InquiryTemplate) {
  _selected.value = item;
  _editSubject.value = item.subject ?? "";
  _editBody.value = item.body ?? "";
}

function onCancel() {
  _selected.value = undefined;
}

function onSave() {
  const t_item = _selected.value;
  if (!t_item) return;
  notificationService.showYesNo(
    "Vorlage speichern",
    `Die Vorlage „${t_item.mailTypeText}“ wird gespeichert. Bestehende Entwürfe bleiben unverändert. Fortfahren?`,
    async () => {
      const t_ok = await apiRegistrationInquiry.saveTemplates(props.insurerId, [{
        mailTypeId: t_item.mailTypeId,
        subject: _editSubject.value,
        body: _editBody.value,
      }]);
      if (t_ok) {
        notificationService.success("Vorlage wurde gespeichert");
        await load();
      }
    });
}

watch(() => props.insurerId, load);
onMounted(load);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardTitle, null, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createTextVNode("Vorlagen Recherche-Mails", -1)
        ]))]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          (!_selected.value)
            ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_items.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.mailTypeId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.mailTypeText), 1),
                      _createElementVNode("td", null, [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-pencil",
                          tooltip: "Vorlage bearbeiten",
                          onClick: ($event: any) => (onSelect(item))
                        }, null, 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createBlock(SogFlexColumn, { key: 1 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createTextVNode(_toDisplayString(_selected.value.mailTypeText) + ". Platzhalter: ", 1),
                    _cache[3] || (_cache[3] = _createElementVNode("b", null, "{Absender}", -1)),
                    _cache[4] || (_cache[4] = _createTextVNode(" (Name der freigebenden Person, in der Signatur), ", -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("b", null, "{Kennzeichen}", -1)),
                    _cache[6] || (_cache[6] = _createTextVNode(" (nur Betreff), ", -1)),
                    _cache[7] || (_cache[7] = _createElementVNode("b", null, "{Liste}", -1)),
                    _cache[8] || (_cache[8] = _createTextVNode(", ", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("b", null, "{Bestehende}", -1)),
                    _cache[10] || (_cache[10] = _createTextVNode(", ", -1)),
                    _cache[11] || (_cache[11] = _createElementVNode("b", null, "{Stelle}", -1)),
                    _cache[12] || (_cache[12] = _createTextVNode(", ", -1)),
                    _cache[13] || (_cache[13] = _createElementVNode("b", null, "{Datum}", -1)),
                    _cache[14] || (_cache[14] = _createTextVNode(" (nur Erinnerung). ", -1))
                  ]),
                  _createVNode(SogTextBox, {
                    modelValue: _editSubject.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_editSubject).value = $event)),
                    placeholder: "Betreff",
                    width: "100%"
                  }, null, 8, ["modelValue"]),
                  _createVNode(SogTextBox, {
                    modelValue: _editBody.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_editBody).value = $event)),
                    placeholder: "Text",
                    multiline: true,
                    width: "100%"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }))
        ]),
        _: 1
      }),
      (_selected.value)
        ? (_openBlock(), _createBlock(SogCardActions, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-content-save",
                tooltip: "Vorlage speichern",
                onClick: onSave
              }),
              _createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-cancel",
                tooltip: "Abbrechen",
                onClick: onCancel
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})